import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '5px 0 10px',
        alignItems: 'flex-start',
        gap: '15px',

    },
    name: {
        fontSize: '16px',
        fontWeight: '600',
        '.lightTheme &': {
            color: '#222'
        }
    },
    btn: {
        textTransform: 'initial'
    },
    divider: {
        width: '100%'
    },
    inner:{
        width:'100%'
    },
}